import { useQueryClient } from '@tanstack/react-query'
import { useDeleteProvidersUserIdLicensesLicenseId, getGetProvidersUserIdQueryKey } from '@/api/generated/doctor/doctor'
import type { DoctorAdminApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

export function useDeleteLicense(userId: string) {
  const queryClient = useQueryClient()
  const { mutate: orvalMutate, isPending } = useDeleteProvidersUserIdLicensesLicenseId()

  function mutate(licenseId: string, opts?: { onSuccess?: () => void; onError?: () => void }) {
    const queryKey = getGetProvidersUserIdQueryKey(userId)
    const previous = queryClient.getQueryData(queryKey)

    // Optimistic: remove license from cached provider data
    queryClient.setQueryData(queryKey, (old: DoctorAdminApiOutContract | undefined) => {
      if (!old?.Licenses) return old
      return {
        ...old,
        Licenses: old.Licenses.filter((l) => l.LicenseId !== licenseId),
      }
    })

    orvalMutate(
      { userId, licenseId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey })
          opts?.onSuccess?.()
        },
        onError: () => {
          queryClient.setQueryData(queryKey, previous)
          opts?.onError?.()
        },
      },
    )
  }

  return { mutate, isPending }
}
